// components/business/message-container/components/box/chat-msg-box/chat-msg-box.js
Component({
    /**
     * 组件的属性列表
     */
    properties: {
        msg: {
            type: Object,
            value: {},
            observer: function (msg) {
                // console.log('lld::robot-msg='+msg)
            },
        },
        // 展示所有图片消息集合
        imgUrls: {
            type: Array,
            value: [],
        }
    },

    /**
     * 组件的方法列表
     */
    methods: {},
});
